import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { OrderLine } from '@models/order';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';
import { Fragment } from 'react';

import CartItem from './CartItem';
import useCartQuantity from './hooks/useCartQuantity';

interface Props {
    shopId: string;
    cartId: string;
}

function CartItems({ shopId, cartId }:Props) {
  const { orderLines } = useCalculatedCart();
  const enableItems = orderLines.filter((orderLine) => orderLine.status !== 'SOLD_OUT');
  const soldOutItems = orderLines.filter((orderLine) => orderLine.status === 'SOLD_OUT');
  useCartQuantity({ shopId, cartId });
  const enableItemQty = enableItems
    .filter((item) => item.status === 'ON_SALE')
    .reduce((acc, cur) => acc + cur.quantity, 0);
  const soldOutItemQty = soldOutItems
    .reduce((acc, cur) => acc + cur.quantity, 0);
  const sortByCartItemId = (orderLine: OrderLine[]) => orderLine.sort(
    (a, b) => b.cartItemId?.localeCompare(a?.cartItemId || '') || 0,
  );
  return (
        <Fragment>
            <Accordion initialOpen
                       title={
                           <Row spacing={10}>
                               <Text size='lg' fontWeight='bold'>
                                   주문 상품
                               </Text>
                               <Text color={colors.gray6}>
                                   총 {enableItemQty.toLocaleString()}건
                               </Text>
                           </Row>
                       }>
                <Column fullWidth as='section' spacing={24}>
                    {sortByCartItemId(enableItems)
                      .map((item) => (
                        <CartItem item={item}
                                  key={item.cartItemId}/>
                      ))}
                </Column>
            </Accordion>
            {soldOutItems.length !== 0 && (
                <Fragment>
                    <Divider/>
                    <Accordion initialOpen
                               title={
                                   <Row spacing={10}>
                                       <Text size='lg' fontWeight='bold'>
                                           품절상품
                                       </Text>
                                       <Text color={colors.gray6}>
                                           총 {soldOutItemQty.toLocaleString()}건
                                       </Text>
                                   </Row>
                               }>
                        <Column fullWidth as='section' spacing={24}>
                            {sortByCartItemId(soldOutItems)
                              .map((item) => (
                                    <CartItem item={item}
                                              key={item.cartItemId}/>
                              ))}
                        </Column>
                    </Accordion>
                </Fragment>
            ) }
        </Fragment>
  );
}

export default CartItems;
